import { useContext } from "react";
import ContactContext from "../contexts/contact-context";

export const useContact = () => useContext(ContactContext);
